/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { userSessionsList } from "../funcs/userSessionsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListUserSessionsRequest,
  ListUserSessionsResponse,
  ListUserSessionsSecurity,
  QueryParamStatus,
} from "../models/operations/listusersessions.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type UserSessionsQueryData = ListUserSessionsResponse;

export type UserSessionsInfiniteQueryData = PageIterator<
  ListUserSessionsResponse,
  { cursor: string }
>;

export type UserSessionsPageParams = PageIterator<
  ListUserSessionsResponse,
  { cursor: string }
>["~next"];

export function prefetchUserSessions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUserSessionsRequest | undefined,
  security?: ListUserSessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildUserSessionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchUserSessionsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListUserSessionsRequest | undefined,
  security?: ListUserSessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildUserSessionsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as UserSessionsPageParams,
    getNextPageParam: (previousPage: UserSessionsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildUserSessionsQuery(
  client$: GramCore,
  request?: ListUserSessionsRequest | undefined,
  security?: ListUserSessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<UserSessionsQueryData>;
} {
  return {
    queryKey: queryKeyUserSessions({
      subjectUrn: request?.subjectUrn,
      userSessionIssuerId: request?.userSessionIssuerId,
      status: request?.status,
      clientId: request?.clientId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionsQueryFn(
      ctx,
    ): Promise<UserSessionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(userSessionsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildUserSessionsInfiniteQuery(
  client$: GramCore,
  request?: ListUserSessionsRequest | undefined,
  security?: ListUserSessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, UserSessionsPageParams>,
  ) => Promise<UserSessionsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyUserSessionsInfinite({
      subjectUrn: request?.subjectUrn,
      userSessionIssuerId: request?.userSessionIssuerId,
      status: request?.status,
      clientId: request?.clientId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function userSessionsQuery(
      ctx,
    ): Promise<UserSessionsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(userSessionsList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(userSessionsList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyUserSessions(
  parameters: {
    subjectUrn?: string | undefined;
    userSessionIssuerId?: string | undefined;
    status?: QueryParamStatus | undefined;
    clientId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessions", "list", parameters];
}

export function queryKeyUserSessionsInfinite(
  parameters: {
    subjectUrn?: string | undefined;
    userSessionIssuerId?: string | undefined;
    status?: QueryParamStatus | undefined;
    clientId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "userSessions", "list", "infinite", parameters];
}
